import React, { useState } from 'react';
import cancelIcon from '../../../../assets/icons/cross.svg';
import { paymentDueData } from '../properties';
import { useStyles } from './style';

import { Modal, Button, Input, Loader, Textarea } from '@mantine/core';
import { hasLength, useForm } from '@mantine/form';

function NotifyPopup({ opened, close }) {
  const { classes } = useStyles(useStyles);
  const [isLoading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      message: ''
    },
    validate: {
      message: hasLength(
        { min: 2, max: 255 },
        'Message must be 2-255 characters long.'
      )
    }
  });

  const handleSubmit = async (values) => {};

  return (
    <Modal
      withCloseButton={false}
      opened={opened}
      onClose={close}
      size="lg"
      title={paymentDueData.titles.modalTitle}
      centered={true}
      styles={{
        content: classes.content,
        title: classes.modalTitle
      }}
    >
      <img
        onClick={close}
        className={classes.cancelIconModal}
        src={cancelIcon}
        height={14}
        width={14}
        alt="cancel"
      />
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Input.Wrapper
          label="Message"
          mx="auto"
          padding={0}
          styles={{
            label: classes.label
          }}
        >
          <Textarea
            mask=""
            className={classes.textInput}
            {...form.getInputProps('Message')}
            placeholder="Message"
            minRows={5}
          />
        </Input.Wrapper>
        <div className={classes.footerWrapper}>
          <Button
            type="submit"
            mt="xl"
            radius="xl"
            ta="right"
            size="lg"
            variant="filled"
            className={classes.cancelButton}
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            mt="xl"
            radius="xl"
            ta="right"
            size="lg"
            variant="filled"
            className={classes.notifyButton}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader
                color="primary.0"
                size="md"
                variant="bars"
                className={classes.loader}
              />
            ) : (
              'Notify'
            )}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default NotifyPopup;
